// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IHairColorType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class HairColorType implements IHairColorType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Bald HairColorType
	**/
    get BAL(): IHairColorType {
        return this.FromId(1);
    }
    /**
		Returns Black HairColorType
	**/
    get BLK(): IHairColorType {
        return this.FromId(2);
    }
    /**
		Returns Blond HairColorType
	**/
    get BLN(): IHairColorType {
        return this.FromId(3);
    }
    /**
		Returns Brown HairColorType
	**/
    get BRO(): IHairColorType {
        return this.FromId(4);
    }
    /**
		Returns Gray HairColorType
	**/
    get GRY(): IHairColorType {
        return this.FromId(5);
    }
    /**
		Returns Red/Auburn HairColorType
	**/
    get RED(): IHairColorType {
        return this.FromId(6);
    }
    /**
		Returns Sandy HairColorType
	**/
    get SDY(): IHairColorType {
        return this.FromId(7);
    }
    /**
		Returns White HairColorType
	**/
    get WHI(): IHairColorType {
        return this.FromId(8);
    }
    /**
		Returns Unknown HairColorType
	**/
    get UNK(): IHairColorType {
        return this.FromId(9);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'BAL', displayValue: 'Bald', description: 'Bald', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'BLK', displayValue: 'Black', description: 'Black', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'BLN', displayValue: 'Blond', description: 'Blond', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'BRO', displayValue: 'Brown', description: 'Brown', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'GRY', displayValue: 'Gray', description: 'Gray', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'RED', displayValue: 'Red/Auburn', description: 'Red/Auburn', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'SDY', displayValue: 'Sandy', description: 'Sandy', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'WHI', displayValue: 'White', description: 'White', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'UNK', displayValue: 'Unknown', description: 'Unknown', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IHairColorType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IHairColorType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IHairColorType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IHairColorType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IHairColorType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
